import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type {
  EquipmentAvailability,
  GetEquipmentAvailabilityQuery,
  GetEquipmentPingsQuery,
  GetEquipmentPingsResponseBody,
} from "../types";

type EquipmentPingsFilters = Omit<GetEquipmentPingsQuery, "cursor">;

export const createEquipmentQueries = (api: CoreApiClient) => {
  const { client } = api;

  const availability = async (
    buildingId: string,
    equipmentId: string,
    query: GetEquipmentAvailabilityQuery,
  ): Promise<EquipmentAvailability> => {
    const { data, error } = await client.GET(`/buildings/{buildingId}/equipments/{equipmentId}/availability`, {
      params: { path: { buildingId, equipmentId }, query },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  const pings = async (
    buildingId: string,
    equipmentId: string,
    filters: EquipmentPingsFilters,
    cursor?: string,
  ): Promise<GetEquipmentPingsResponseBody> => {
    const { data, error } = await client.GET(`/buildings/{buildingId}/equipments/{equipmentId}/pings`, {
      params: { path: { buildingId, equipmentId }, query: { ...filters, cursor } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    availability,
    pings,
    queries: createQueryKeys("equipment", {
      availability: (buildingId: string, equipmentId: string, query: GetEquipmentAvailabilityQuery) => ({
        queryKey: [buildingId, equipmentId, query],
        queryFn: () => availability(buildingId, equipmentId, query),
      }),
      pings: (buildingId: string, equipmentId: string, filters: EquipmentPingsFilters) => ({
        queryKey: [buildingId, equipmentId, filters],
        queryFn: ({ pageParam }: { pageParam?: string }) => pings(buildingId, equipmentId, filters, pageParam),
      }),
    }),
  };
};
